import React from "react";
import {Route,Redirect} from "react-router-dom";
import {Content} from "./Content";

export function ContentRoute({ children, component,userRoles,Restriction,role,render, ...props }) {
  // console.log("userRoles : ",userRoles)
  // console.log("role : ",role)
  const canAccess = Restriction ? userRoles.find((findUser)=> findUser === role||'') : true
  // console.log("canAccess : ",canAccess)
    if(canAccess){
      return (
        <Route {...props}>
          {routeProps => {
            if (typeof children === "function") {
              return <Content>{children(routeProps)}</Content>;
            }

            if (!routeProps.match) {
              return null;
            }

            if (children) {
              return <Content>{children}</Content>;
            }

            if (component) {
              return (
                <Content>{React.createElement(component, routeProps)}</Content>
              );
            }

            if (render) {
              return <Content>{render(routeProps)}</Content>;
            }

            return null;
          }}
        </Route>
      );
    }else{
      return (<Redirect to="/app/customers" />);
    }
}
